import { throttle } from 'lodash-es'
import type { Ref } from 'vue'
import { computed, ref } from 'vue'

export const useMessageViewScrollingControl = (
  isDisabledToScrollToBottom: Ref<boolean>,
  scrollingThrottleIntervalMs: number,
  onScrollTopZero: () => void
) => {
  const messageView = ref<HTMLElement | null>(null)

  const scrollMessageViewToBottom = (): void => {
    if (isDisabledToScrollToBottom.value || messageView.value === null) {
      return
    }
    messageView.value.scrollTop = messageView.value.scrollHeight
  }

  const throttledMessageViewOnScrollHandler = computed(() => {
    return throttle((): void => {
      if (messageView.value === null) {
        return
      }

      if (messageView.value.scrollTop <= 0) {
        onScrollTopZero()
        return
      }

      if (
        !isDisabledToScrollToBottom.value &&
        messageView.value.scrollTop + messageView.value.clientHeight + 500 <
          messageView.value.scrollHeight
      ) {
        isDisabledToScrollToBottom.value = true
        return
      }

      if (
        isDisabledToScrollToBottom.value &&
        messageView.value.scrollTop + messageView.value.clientHeight >=
          messageView.value.scrollHeight
      ) {
        isDisabledToScrollToBottom.value = false
      }
    }, scrollingThrottleIntervalMs)
  })

  return {
    messageView,
    scrollMessageViewToBottom,
    throttledMessageViewOnScrollHandler,
  }
}
